import { SearchParams } from '@/types'
import { DeleteType } from '@/types/hydraulic'
import {
  IWaterTankLevelHistoryType,
  IWaterTankLevelTopValveSearchParams,
} from '@/types/waterTank'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export interface IFillValveBase {
  id: number
  valveAddress: number
  valveIndex: number
  automateWaterFill: boolean
  autoOnLevel: number
  autoOffLevel: number
}

export interface IFillValve extends IFillValveBase {
  interfaceId?: number
  status?: boolean
  name?: string
}

export interface IWaterTankBase {
  interfaceId: number
  sensorId: string
  sensorAddress: number
  sensorIndex: number
  name: string
  waterTankArea: number
  heightToOverflow: number
  lowLevelAlarm: number
  highLevelAlarm: number
  volume: number
  fillValves: IFillValve[]
}

export interface IFillValve {
  id: number
  valveId: string
  valveAddress: number
  valveIndex: number
  automateWaterFill: boolean
  autoOnLevel: number
  autoOffLevel: number
  status?: boolean
  name?: string
}

export interface IWaterTank {
  id: number
  interfaceId: number
  sensorId: string
  sensorAddress: number
  sensorIndex: number
  name: string
  waterTankArea: number
  heightToOverflow: number
  lowLevelAlarm: number
  highLevelAlarm: number
  creationTime: string // Consider converting to Date if needed
  lastSync: string // Consider converting to Date if needed
  volume: number
  fillValves: IFillValve[]
}

export interface IWaterTank extends IWaterTankBase {
  id: number
  creationTime: string
  lastSync: string
}

export type IWaterTankCreate = IWaterTankBase

export interface ITopupValve {
  id: string
  interfaceId: number
  index: number
  address: number
  name: string
  hiddenAddress: string | null

  [key: string]: unknown
}

export const waterTankApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = `api/WaterTank/${searchParams.interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(payload: any): Promise<{ data: any }> {
    const { id, interfaceId } = payload
    const url = `api/WaterTank/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  getTankLevelSensors(interfaceId: number, waterTankId?: number) {
    let url = `/api/WaterTank/${interfaceId}/sensors?interfaceId=${interfaceId}`
    if (waterTankId) {
      url = `/api/WaterTank/${interfaceId}/sensors?interfaceId=${interfaceId}&WaterTankId=${waterTankId}`
    }

    return axiosClient.get(url)
  },

  getLastUpdateWaterTank(interfaceId: number) {
    const url = `/api/watertank/last-updatede?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getWaterActivity(interfaceId: number, address: number, index: number) {
    const url = `/api/WaterTank/${interfaceId}/activities?interfaceId=${interfaceId}&address=${address}&index=${index}`
    return axiosClient.get(url)
  },

  createWaterTank(payload: IWaterTankCreate) {
    const url = `/api/WaterTank/${payload.interfaceId}`
    return axiosClient.post(url, payload)
  },

  update(payload: IWaterTank) {
    const { id, interfaceId } = payload
    const url = `api/WaterTank/${interfaceId}/${id}`
    return axiosClient.put(url, payload)
  },

  getWaterActivityById(searchParams: SearchParams = {}) {
    const url = `/api/WaterTank/${searchParams.interfaceId}/activities`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  delete(payload: DeleteType) {
    const { id, interfaceId } = payload
    const url = `api/WaterTank/${interfaceId}/${id}`
    return axiosClient.delete(url)
  },

  getWaterTankLevelHistory(searchParams: IWaterTankLevelHistoryType) {
    const url = `/api/WaterTank/${searchParams.interfaceId}/${searchParams.id}/history`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getTopupValves(
    searchParams: IWaterTankLevelTopValveSearchParams,
  ): Promise<{ data: ITopupValve[] }> {
    const url = `api/WaterTank/${searchParams.interfaceId}/valves`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  useGetListWaterResourceReport(
    interfaceId: number,
    month: number,
    year: number,
    monthsBefore: number = 1,
  ) {
    const url = `/api/v2/watersource/report/monthly?interfaceId=${interfaceId}&month=${month}&year=${year}&monthsBefore=${monthsBefore}`
    return axiosClient.get(url)
  },
  getListWaterResourceReport(
    interfaceId: number,
    month: number,
    year: number,
    monthsBefore: number = 1,
  ) {
    const url = `/api/v2/watersource/report/monthly?interfaceId=${interfaceId}&month=${month}&year=${year}&monthsBefore=${monthsBefore}`
    return axiosClient.get(url)
  },
}
